import type {
  Configuration,
  ExportComplianceReportRequest,
} from '@repo/api-gw-sdk';
import { ComplianceApi } from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/compliance/';

export const compliance = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const complianceApi = new ComplianceApi(config);

  return {
    useResources: (page = 0, pageSize = 10000) =>
      httpClient.execute(
        complianceApi.listComplianceResources.bind(complianceApi),
        baseUrl,
        `resources-${page}-${pageSize}`,
        currentProjectId,
        page,
        pageSize
      ),
    useTrend: (days = 90, filter?: string, enabled = true) =>
      httpClient.execute(
        complianceApi.getComplianceTrend.bind(complianceApi),
        enabled ? baseUrl : null,
        `trend-${days}-${filter ?? ''}`,
        currentProjectId,
        filter,
        days
      ),
    exportReport: (body: ExportComplianceReportRequest, filter?: string) =>
      complianceApi.exportComplianceReport(currentProjectId, body, filter),
  };
};
